module.exports = __webpack_public_path__ + "static/media/Portugal.9ad5552c.jpg";